import React from "react";

import Portal from "../../common/components/Portal";
import GeneralTaskManager from "../index";
import Draggable from "react-draggable";

const TaskManagerModal = ({ onCancel }) => {
    return (
        <Portal
            body={
                <Draggable handle=".draggable" cancel=".non-draggable">
                    <div className="modal modal-region task-manager-modal" id="modalId" style={{ display: "block" }} tabIndex="-1">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header draggable">
                                    <h5 className="modal-title">Task Manager</h5>
                                    <button type="button" className="close non-draggable" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="" />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body ">
                                    <div className="dashboard-outer">
                                        <div className="outer-detail">
                                            <div className="right-panel-section m-0">
                                                <div className="dtl-sec p-0 m-0">
                                                    <div className="dtl-sec system-building col-md-12 m-0 p-0 ">
                                                        <div className="tab-dtl region-mng">
                                                            <div className="tab-active recomdn-table bg-grey-table modal-table-scroll">
                                                                <GeneralTaskManager />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            }
            onCancel={onCancel}
        />
    );
};

export default TaskManagerModal;
